import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PlanFiltersDTO } from '../../../dtos/plans.dto';
import { PlansService } from '../../../services/plans/plans.service';

@Component({
  selector: 'app-plans-filter-container',
  templateUrl: './plans-filter-container.component.html',
  styleUrl: './plans-filter-container.component.scss',
  standalone: false,
})
export class PlansFilterContainerComponent implements OnInit, OnDestroy {
  searchFilters: PlanFiltersDTO = {
    title: '',
    school_year: '',
  };

  subs: Subscription[] = [];

  constructor(private plansService: PlansService) {}

  ngOnInit(): void {
    this.subs.push(
      this.plansService.searchFilters.subscribe((searchFilters) => {
        if (searchFilters) {
          this.searchFilters = searchFilters;
        }
      })
    );
  }

  applyFilters() {
    this.plansService.setFilters(this.searchFilters);
  }

  removeKeywordFilter() {
    if (this.searchFilters) {
      this.searchFilters.title = '';
      this.applyFilters();
    }
  }

  removeSchoolYearFilter() {
    if (this.searchFilters) {
      this.searchFilters.school_year = '';
      this.applyFilters();
    }
  }

  ngOnDestroy() {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }
  }
}
